export default class Accordion {
  constructor() {
    this.component = $(".esf-accordion");
    this.init();
  }
  init() {
    const trigger = this.component.find(".esf-accordion__trigger");
    const link = this.component.find(".esf-accordion__trigger a");
    const target  = this.component.find(".esf-accordion__target");
    const closeAll = this.component.find(".esf-accordion__close-all");
    const openAll = this.component.find(".esf-accordion__open-all");

    target.hide();
    target.filter('.-is-open').show();

    trigger.click(function(e) {

      // Current accordion
      const currentAccordion = $(this).parent().parent();

      // Direct sibling
      const target = $(this).next(".esf-accordion__target");

      // All open triggers
      const openTrigger = $(this)
        .parent()
        .parent()
        .find(".esf-accordion__trigger.-is-open");

      // All open targets
      const openTarget = $(this)
        .parent()
        .parent()
        .find(".-is-open + .esf-accordion__target");

      if ($(this).hasClass("-is-open")) {
        target.slideUp(400, "easeInCubic");
        $(this).removeClass("-is-open");
      } else {
        if (!currentAccordion.hasClass("esf-accordion--info-tiles")) {
          openTrigger.removeClass("-is-open");
          openTarget.slideUp(400, "easeInCubic");
        }
        $(this).addClass("-is-open");
        target.slideDown(400, "easeOutCubic");
      }
    });

    link.click(function(e) {

      // Direct sibling
      const target = $(this).parent().next(".esf-accordion__target");

      // All open triggers
      const openTrigger = $(this)
        .parent()
        .parent()
        .parent()
        .find(".esf-accordion__trigger.-is-open");

      openTrigger.removeClass("-is-open");
      $(this).addClass("-is-open");
      target.slideDown(400, "easeOutCubic");
    });

    openAll.click(function(e) {

      const closeButton = $(this)
        .parent()
        .find(".esf-accordion__close-all");

      $(this).removeClass("esf-button--filled").addClass("esf-button--outlined");
      closeAll.removeClass("esf-button--outlined").addClass("esf-button--filled");

      // All open triggers
      const allTriggers = $(this)
        .parent()
        .parent()
        .find(".esf-accordion__trigger");

      // All open targets
      const allTargets = $(this)
        .parent()
        .parent()
        .find(".esf-accordion__target");

      allTriggers.addClass("-is-open");
      allTargets.slideDown(400, "easeOutCubic");
    });

    closeAll.click(function(e) {

      const openButton = $(this)
        .parent()
        .find(".esf-accordion__open-all");

      $(this).removeClass("esf-button--filled").addClass("esf-button--outlined");
      openAll.removeClass("esf-button--outlined").addClass("esf-button--filled");

      // All open triggers
      const openTrigger = $(this)
        .parent()
        .parent()
        .find(".esf-accordion__trigger.-is-open");

      // All open targets
      const openTarget = $(this)
        .parent()
        .parent()
        .find(".-is-open + .esf-accordion__target");

      openTrigger.removeClass("-is-open");
      openTarget.slideUp(400, "easeInCubic");
    });
  }
}
